export const LangText: any = {
    us: {
        TableOfContents: 'Table of contents',
    },
    de: {
        TableOfContents: 'Inhaltsverzeichnis',
    },
    fr: {
        TableOfContents: 'Table des matières',
    },
    it: {
        TableOfContents: 'Indice',
    },
    es: {
        TableOfContents: 'Tabla de contenido',
    },
    jp: {
        TableOfContents: '目次',
    },
    kr: {
        TableOfContents: '카테고리',
    },
    mx: {
        TableOfContents: 'Índice',
    },
    br: {
        TableOfContents: 'Índice',
    },
};
